import React from 'react';
import Link from 'next/link';
import styled from '../../../libs/styled.es.js';

const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
const CustomLink = ({
  targetPath,
  children,
  targetType = "_self"
}) => {
  if (!targetPath)
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  if (targetPath.startsWith("http"))
    return /* @__PURE__ */ React.createElement(Anchor, {
      target: targetType,
      href: targetPath
    }, children);
  return /* @__PURE__ */ React.createElement(Link, {
    href: targetPath,
    passHref: true,
    legacyBehavior: true
  }, /* @__PURE__ */ React.createElement(Anchor, {
    target: targetType
  }, children));
};

export { CustomLink };
